import { useRouter } from "next/router";
import useSWR, { SWRConfiguration } from "swr";
import useProjects from "./useProjects";
import useIsTeam from "./useIsTeam";
import { ObjectToQueryString } from "../helpers";
import { get } from "@/backend";

const useProject = (
  payload?:
    | string
    | {
        name?: string;
        options?: SWRConfiguration;
      },
) => {
  const name = typeof payload === "string" ? payload : payload?.name;
  let options = {};
  if (typeof payload === "object") {
    options = payload?.options || {};
  }

  const { projects, mutate: mutateProjects } = useProjects({ useStore: true });
  const { isTeam } = useIsTeam();
  const router = useRouter();

  const { data, error, mutate, isLoading } = useSWR(
    name && `/v1/projects/${name}`,
    get,
    {
      onError: (error) => {
        if (
          error?.response?.data?.message === "Project not found" ||
          error?.response?.data?.errors?.[0].msg === "Project not found" ||
          error?.response?.status === 404
        ) {
          router.push("/404");
        }
      },

      onSuccess: (data) => {
        const project = data?.data;
        if (!isTeam && project?.team) {
          const hasQuery = Object.keys(router.query).length > 0;

          router.push(
            `/teams/${project?.team?.name}/projects/${project?.name}${
              hasQuery ? `?${ObjectToQueryString(router.query)}` : ""
            }`,
          );
        }
      },

      fallbackData: {
        data:
          projects?.projects?.find(
            (project: { name: string }) => project.name === name,
          ) || {},
      },
      ...options,
    },
  );

  return {
    project: data?.data || {},
    loading: isLoading && !data?.data,
    isInitialLoading: isLoading,
    error,
    mutate,
    mutateProjects,
    projects,
  };
};
export default useProject;
